function mulberry32(seed: number) {
  let a = seed;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function uniformBucket(
  rand: () => number,
  count: number,
  low: number,
  high: number,
): number[] {
  const out: number[] = [];
  for (let i = 0; i < count; i++) {
    out.push(low + rand() * (high - low));
  }
  return out;
}

export const SCALE = { min: 0, max: 1000, pass: 650 };

export function generateScorePopulation(): number[] {
  const rand = mulberry32(42);
  const scores: number[] = [];

  scores.push(...uniformBucket(rand, 1200, 800, 1000));
  scores.push(...uniformBucket(rand, 750, 750, 800));
  scores.push(...uniformBucket(rand, 510, 700, 750));
  scores.push(...uniformBucket(rand, 330, 650, 700));
  scores.push(...uniformBucket(rand, 90, 600, 650));
  scores.push(...uniformBucket(rand, 60, 550, 600));
  scores.push(...uniformBucket(rand, 35, 400, 550));
  scores.push(...uniformBucket(rand, 20, 250, 400));
  scores.push(...uniformBucket(rand, 5, 50, 250));

  return scores;
}

export const POPULATION = generateScorePopulation();

export interface ScoreBand {
  bin: string;
  low: number;
  high: number;
  count: number;
  pct: number;
}

export function buildBands(scores: number[], step = 50): ScoreBand[] {
  const bands: ScoreBand[] = [];
  for (let low = 0; low < 1000; low += step) {
    const high = low + step;
    const count = scores.filter(
      (s) => s >= low && (high >= 1000 ? s <= high : s < high),
    ).length;
    bands.push({
      bin: `${low}–${high}`,
      low,
      high,
      count,
      pct: +((count / scores.length) * 100).toFixed(2),
    });
  }
  return bands;
}

export function approvalRate(scores: number[], threshold: number): number {
  let approved = 0;
  for (const s of scores) if (s >= threshold) approved++;
  return (approved / scores.length) * 100;
}
